import axiosInstance from "../utils/axios";
import { Subscription } from "../@types/feature";

const SAAS_SUBSCRIPTIONS_API = '/subscriptions/v1/merchant-saas';

const getSubscriptionsApi = (merchantCode: string) => {
  return axiosInstance
    .get(`${SAAS_SUBSCRIPTIONS_API}/${merchantCode}`);
}

const startTrialApi = (merchantCode: string, trialSubscription: Subscription) => {
    return axiosInstance
        .post(`${SAAS_SUBSCRIPTIONS_API}/${merchantCode}/start-trial`, trialSubscription);
}

const getSubscriptionPlans = () => {
  return axiosInstance.get(`${SAAS_SUBSCRIPTIONS_API}/plans`);
};

export interface ICreateUpdateToAnnualSaasSubscriptionLink {
    priceId: string;
    successUrl: string;
    cancelUrl: string;
}

const createUpdateToAnnualSaasSubscriptionLink = (merchantCode: string, data: ICreateUpdateToAnnualSaasSubscriptionLink) => {
    return axiosInstance.post(
        `${SAAS_SUBSCRIPTIONS_API}/update-confirm-flow/${merchantCode}`, JSON.stringify(data));
}

const cancelSubscription = (merchantCode: string, data: any) => {
  return axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/cancel-flow/${merchantCode}`, JSON.stringify(data));
}

const updatePaymentMethod = (merchantCode: string, data: any) => {
  return axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/update-payment-method-flow/${merchantCode}`, JSON.stringify(data));
}

export {
  getSubscriptionsApi,
  startTrialApi,
  getSubscriptionPlans,
  createUpdateToAnnualSaasSubscriptionLink,
  cancelSubscription,
  updatePaymentMethod,
};
